import type { BaseMarkupComponent } from '~/models/BaseMarkupComponent.model';
const COMPONENT_PAGE_THEME = 'pagetheme' as const;
const ALLOWED_MARKUP_THEMES = ['blackweek-theme', 'christmas-theme'] as const;

export const general_setPageTheme = (markupContent?: BaseMarkupComponent[]) => {
  if (!markupContent) {
    return;
  }

  const classStringFromMarkup = computed(() => {
    const pageThemeComponentFromPageMarkup = markupContent.find(
      (component) =>
        component.Component?.toLocaleLowerCase() === COMPONENT_PAGE_THEME,
    );

    if (!pageThemeComponentFromPageMarkup) {
      return '';
    }

    const classString = pageThemeComponentFromPageMarkup.Class;

    if (!classString) {
      return '';
    }

    if (!ALLOWED_MARKUP_THEMES.includes(classString)) {
      return '';
    }
    return classString;
  });

  // TODO: After blackweek/christmas 2025: read css from browser to determine light or dark?
  //const preferredLightOrDarkThemeClass = '';

  useHead({
    bodyAttrs: {
      class: [classStringFromMarkup],
    },
  });
};
